import {  QUERY_GET_DOCUMENTATION_REQUEST_TEMPLATES } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getDocumentationRequestTemplates = baseThunk("documentationRequestTemplates/documentationRequestTemplates", QUERY_GET_DOCUMENTATION_REQUEST_TEMPLATES, "GET")